/**
 * Vue Archive/Filter App
 * Product listing and filtering system
 */

import { createApp } from 'vue';
import ArchiveApp from './components/ArchiveApp.vue';

// Initialize Vue app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	const archiveContainer = document.getElementById('archive-app');

	if (archiveContainer) {
		const app = createApp(ArchiveApp);

		// Make WordPress data available to Vue
		app.config.globalProperties.$wordpress = {
			ajaxUrl: window.trendsData?.ajaxUrl || '/wp-admin/admin-ajax.php',
			nonce: window.trendsData?.nonce || '',
			siteUrl: window.trendsData?.siteUrl || '',
		};

		app.mount('#archive-app');
	}
});
